import React, { memo, useMemo, useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { get } from "lodash";

import flagUs from "../../assets/images/flags/en.png";
import flagRu from "../../assets/images/flags/ru.png";
import flagUz from "../../assets/images/flags/uz.png";
import { useShallowEqualSelector } from "../../hooks/useShallowSelector";
import { appLanguageSelector, switchLanguage } from "../../reducers/AppReducer";
import { useDispatch } from "react-redux";
import { AppLanguage, listLanguages } from "../../i18n/I18nContext";

const languages = {
  Ru: {
    label: "Russian",
    flag: flagRu,
  },
  En: {
    label: "English",
    flag: flagUs,
  },
  Uz: {
    label: "Uzbek",
    flag: flagUz,
  },
};
export default memo(function LanguageDropdown() {
  const [isLanguageDropdown, setIsLanguageDropdown] = useState(false);
  const toggleLanguageDropdown = () => {
    setIsLanguageDropdown(!isLanguageDropdown);
  };
  const language = useShallowEqualSelector(appLanguageSelector);
  const dispatch = useDispatch();
  const onSelect = (value: AppLanguage) => dispatch(switchLanguage({ language: value }));
  const list = useMemo(() => listLanguages().filter((x) => x !== language), [language]);
  return (
    <React.Fragment>
      <Dropdown
        isOpen={isLanguageDropdown}
        toggle={toggleLanguageDropdown}
        className="ms-1 topbar-head-dropdown header-item"
      >
        <DropdownToggle
          className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
          tag="button"
        >
          <img
            src={get(languages, `${language}.flag`, `${languages.Ru.flag}`)}
            alt="Header Language"
            height="20"
            className="rounded"
          />
        </DropdownToggle>
        <DropdownMenu className="notify-item language py-2">
          {list.map((x) => (
            <DropdownItem
              key={x}
              onClick={() => onSelect(x)}
              className={`notify-item ${language === x ? "active" : "none"}`}
            >
              <img
                src={get(languages, `${x}.flag`)}
                alt="Skote"
                className="me-2 rounded"
                height="18"
              />
              <span className="align-middle">{get(languages, `${x}.label`)}</span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
});
